module.exports = __webpack_public_path__ + "img/1.ec9d8a49.svg";